import { NOTIFICATION_TYPE } from '../../constants/notifications.constants';

/**
 * Notifications-screen labels, tabs and URL-param names — no SCSS/JSX
 * imports so the controller, utils and tests can import safely. The row
 * enums themselves (type / severity / resourceType) live in
 * `src/constants/notifications.constants.js` because the header and data
 * layer share them.
 */
export const TYPE_LABELS = Object.freeze({
    [NOTIFICATION_TYPE.ADVANCE_FAILED]: 'Advance failed',
    [NOTIFICATION_TYPE.SETTLEMENT_FAILED]: 'Settlement failed',
    [NOTIFICATION_TYPE.TROUBLE_TICKET_CREATED]: 'Trouble ticket',
    [NOTIFICATION_TYPE.SUPPORT_TICKET_STATUS_CHANGED]: 'Ticket update',
});

export const TYPE_TABS = Object.freeze([
    { key: 'all', label: 'All' },
    { key: NOTIFICATION_TYPE.ADVANCE_FAILED, label: 'Advance failed' },
    { key: NOTIFICATION_TYPE.SETTLEMENT_FAILED, label: 'Settlement failed' },
    { key: NOTIFICATION_TYPE.TROUBLE_TICKET_CREATED, label: 'Trouble tickets' },
    { key: NOTIFICATION_TYPE.SUPPORT_TICKET_STATUS_CHANGED, label: 'Ticket updates' },
]);

/** Time frames offered by `DateFilters` (matches `calculateDateRange`). */
export const VALID_NOTIFICATION_TIMEFRAMES = Object.freeze(['all', '7d', '30d', 'custom']);

export const NotificationsConstants = Object.freeze({
    DEFAULT_PAGE_SIZE: 10,
    LIST_TYPE_PARAM: 'type',
    LIST_TYPE_DEFAULT: 'all',
    LIST_UNREAD_PARAM: 'unread',
    TIMEFRAME_PARAM: 'period',
    DATE_RANGE_PARAM: 'range',
    TIMEFRAME_DEFAULT: 'all',
});

export default NotificationsConstants;
